module.exports = __webpack_public_path__ + "img/254FB0_99AFF0_6587D8_1D3279-256px.b45ddecd.png";